import React from 'react';
import './Footer.css'


const Footer = () => {
    return (
        <div className="mb-3 footer-area">
            <hr/>
            <div className="footer-class">

            <div>
                <ul className="d-flex">
                    <li><a className="footer-text" href="https://www.linkedin.com/in/abdullahalrafee/" target="_blank">LinkedIn</a></li>
                    <li><a className="footer-text" href="https://github.com/Rafee1100" target="_blank">Github</a></li>
                    <li><a className="footer-text" href="https://www.facebook.com/abdullahal.rafee/" target="_blank">Facebook</a></li>
                </ul>
            </div>
            <div className="copy-div ms-auto footer-text pe-3">&copy;2021 || All Rights Reserved, Abdullah Al Rafee</div>                 
            </div>
        </div>
    );
};

export default Footer;